import React, { useState } from "react";
import { WebsiteBuilderToolbarMenuView } from "../../../WebsiteBuilderToolbarMenuView";
import { useTranslation } from "react-i18next";
import Input from "components/form/input";
import Checkbox from "components/form/checkbox/Checkbox";
import { IWebsiteBuilderWebsiteVersionNavigationMenuExternalItem } from "redux/reducers/models/websiteBuilder";
import { ButtonNew as Button } from "components/buttonNew";
import { websiteBuilderUpdateNavigationMenuItem } from "redux/actions/websiteBuilder/editor/websiteBuilderEditor";
import { useAppDispatch, useAppSelector } from "hooks/redux";
import "./updateLinkView.scss";

interface IUpdateLinkViewProps {
  item: IWebsiteBuilderWebsiteVersionNavigationMenuExternalItem;
  disabled: boolean;
  goBackToParentView: () => void;
}

interface IUpdateLinkViewSettings {
  label: string;
  external_url: string;
  open_in_new_tab: boolean;
}

export function UpdateLinkView(props: IUpdateLinkViewProps) {
  const { item, disabled, goBackToParentView } = props;

  const { t } = useTranslation();

  const dispatch = useAppDispatch();

  const navigationMenuItems = useAppSelector(store => store.websiteBuilderStore.editor.navigationMenuItems);

  const [settings, setSettings] = useState<IUpdateLinkViewSettings>({
    label: item.label,
    external_url: item.external_url,
    open_in_new_tab: item.open_in_new_tab,
  });

  const labelValid = settings.label?.length > 0;
  const externalUrlValid = settings.external_url?.length > 0;

  const updateLinkEnabled = !disabled && labelValid && externalUrlValid;

  function renderUpdateLinkSettingsSection() {
    if (item.type !== "external") {
      return <></>;
    } else {
      return (
        <div className="website-builder-update-link-settings-section">
          <Input
            label={t("Label")}
            value={settings.label}
            onChange={e => setSettings(prev => ({ ...prev, label: e.target.value }))}
            error={!labelValid}
          />
          <Input
            label={t("Url")}
            value={settings.external_url}
            onChange={e => setSettings(prev => ({ ...prev, external_url: e.target.value }))}
            error={!externalUrlValid}
          />
          <Checkbox
            size="medium"
            label={t("Open link in new tab")}
            checked={settings.open_in_new_tab}
            onChange={e => setSettings(prev => ({ ...prev, open_in_new_tab: e.target.checked }))}
          />
        </div>
      );
    }
  }

  function updateLink() {
    void dispatch(websiteBuilderUpdateNavigationMenuItem({
      id: item.id,
      page_id: null,
      type: item.type,
      label: settings.label,
      external_url: settings.external_url,
      open_in_new_tab: settings.open_in_new_tab,
      position: item.position,
      parent_id: item.parent_id,
      hidden: item.hidden,
    }, navigationMenuItems, t, goBackToParentView));
  }

  function renderUpdateLinkSaveSection() {
    return (
      <div className="website-builder-update-link-save-section">
        <Button
          type="secondary"
          className="update-link-save-action"
          onClick={goBackToParentView}
        >
          {t("Cancel")}
        </Button>
        {item.type === "external" && (
          <Button
            type="primary"
            className="update-link-save-action"
            onClick={updateLink}
            disabled={!updateLinkEnabled}
          >
            {t("Save")}
          </Button>
        )}
      </div>
    );
  }

  return (
    <WebsiteBuilderToolbarMenuView
      title={t("Update link")}
      goBackToParentView={goBackToParentView}
      footer={renderUpdateLinkSaveSection()}
      sections={[
        {
          content: renderUpdateLinkSettingsSection(),
        },
      ]}
    />
  );
}